// ============================================================================
// hvsin Fetch Contracts
//
// 本包定义 IFetchService 接口及其相关类型。
//
// 设计目的：
// - 浏览器环境：browser-fetch-service-mod 使用原生 fetch() 通过 HTTP 调用 API
// - SSR 环境：  backend-fetch-service-mod 直接调用业务服务，避免 Worker 自调用死锁
//
// 两者实现相同的接口，客户端代码（如 post-api-client）只需依赖此接口，
// 运行时由容器注入具体实现。
// ============================================================================
// ----------------------------------------------------------------------------
// 3. 接口标签常量
// ----------------------------------------------------------------------------
/** IFetchService 接口标签 */
export const FETCH_SERVICE_INTERFACE_TAG = 'IFetchService';
//# sourceMappingURL=index.js.map